// extracted by mini-css-extract-plugin
export default {"wrapper":"_507f5e50","navList":"_9d1654d8","listItem":"_b675d4f4","link":"_be03fe23","isSelected":"_1e177a90"};